import React from 'react';
import {Sport} from "../../models/api/codegen/code";
import {ColoredIcon} from "../Steps/step-parts-components/SportIconAndTitle";

interface IconButtonListProps {
    sports: Record<number, Sport>;
    callback: (sportId: number | undefined) => void;
    sportId?: number;
    handleShowOff: () => void;
}

export const IconButtonList: React.FC<IconButtonListProps> = ({callback, handleShowOff, sports, sportId}) => {
    const handleClick = (sportId: number) => () => {
        callback(sportId);
        handleShowOff();
    };

    return (
        <div className="w-full overflow-hidden whitespace-nowrap overflow-x-auto">
            <div className="overflow-y-hidden whitespace-nowrap">
                {Object.values(sports).map((sport) => (
                    <div key={sport.si} className="inline-block">
                        <div
                            className="flex justify-center items-center rounded-[8px] h-[40px] w-[40px] tablet:h-[56px] tablet:w-[56px] ml-[6px] bg-[#21262B] focus:bg-[#171A1E] cursor-pointer"
                            onClick={handleClick(sport.si)}
                        >
                            <ColoredIcon imageUrl={sport.siu} color={sport.si === sportId ? sport.sc : '#fff'}/>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
